<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    class="mode"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="商品明細選択"
    top="5vh"
    :visible.sync="dialogVisible"
    :show-close="false"
    width="900px"
    append-to-body
    @opened="opened"
    @close="close"
  >
    <vab-query-form-mode
      :model="queryForm"
      :rules="rules"
      class="dpform noborder"
      :enable-query-save="false"
      size="mini"
      label-position="left"
      label-width="180px"
      @search="onSearch"
    >
      <el-row>
        <el-col :span="22">
          <el-form-item label="商品">
            <div style="display: flex">
              <el-col :span="6">
                <el-input
                  v-if="goodslists.length == 1"
                  v-model="goodslists[0].itmcd"
                  disabled
                />
                <el-input
                  v-else-if="goodslists.length > 1"
                  value="<複数>"
                  disabled
                  :class="[goodslists.length > 1 ? 'multiple' : '']"
                />
                <el-input v-else value="" disabled />
              </el-col>
              <el-col :span="18">
                <el-input
                  v-if="goodslists.length == 1"
                  v-model="goodslists[0].itmnm"
                  disabled
                />
                <el-input
                  v-else-if="goodslists.length > 1"
                  value="<複数>"
                  disabled
                  :class="[goodslists.length > 1 ? 'multiple' : '']"
                />
                <el-input v-else value="" disabled />
              </el-col>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-popover
            v-show="goodslists.length > 1"
            placement="bottom"
            trigger="click"
          >
            <el-table :data="goodslists" border stripe max-height="300">
              <el-table-column
                width="80"
                property="itmcd"
                header-align="center"
                label="商品CD"
              ></el-table-column>
              <el-table-column
                width="300"
                header-align="center"
                property="itmnm"
                label="商品名"
              ></el-table-column>
            </el-table>
            <div
              slot="reference"
              class="more_box flex_center flex_center_align more_change_box"
            >
              <div class="inner_box flex_center flex_center_align">
                <svg-icon :icon-class="'sel'"></svg-icon>
              </div>
            </div>
          </el-popover>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="11">
          <vab-input prop="itmdtlcd" label="商品明細名CD" maxlength="3" />
        </el-col>
        <el-col :span="11">
          <vab-input
            prop="itmdtlnmk"
            label="商品明細名(半角ｶﾅ)"
            maxlength="50"
            validate="halfKana"
          />
        </el-col>
      </el-row>
    </vab-query-form-mode>
    <el-row class="m20">
      <el-col :span="24">
        <vab-table
          ref="table"
          api-url="/api/mitmdtlp/query"
          :columns="columns"
          :custom-config="false"
          :multi-select="multiSelect"
          height="350"
          :init-params="queryForm"
          :query-params="queryForm"
          :row-key="getRowKey"
          :enable-init="false"
          @selection-change="setSelectRows"
        />
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer flex_end">
      <div class="flex_start flex_center_align">
        <el-button class="cancel" @click="close">キャンセル</el-button>
        <!-- <div class="cancel" @click="close">キャンセル</div> -->
        <el-button type="primary" @click="save()">確定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import mixDialog from '@/utils/mixDialog'
  export default {
    name: 'MitmdtlpDialog',
    mixins: [mixDialog],
    props: {
      goodslists: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        queryForm: {
          itmdtlcd: null,
          itmdtlnmk: null,
          //商品コードリスト
          itmcdList: null,
        },
        columns: [
          {
            label: '商品CD',
            'min-width': 80,
            prop: 'itmcd',
          },
          {
            label: '商品名',
            'min-width': 120,
            prop: 'itmnm',
          },
          {
            label: '商品明細CD',
            'min-width': 80,
            prop: 'itmdtlcd',
          },
          {
            label: '商品明細名(半角ｶﾅ)',
            'min-width': 120,
            prop: 'itmdtlnmk',
          },
          {
            label: '商品明細名',
            'min-width': 120,
            prop: 'itmdtlnm',
          },
        ],
      }
    },

    methods: {
      getRowKey(row) {
        return row.itmdtlcd
      },
    },
  }
</script>
